import { render } from "./OrganisationIcon.vue?vue&type=template&id=1e1a598d&scoped=true"
import script from "./OrganisationIcon.vue?vue&type=script&lang=js"
export * from "./OrganisationIcon.vue?vue&type=script&lang=js"

import "./OrganisationIcon.vue?vue&type=style&index=0&id=1e1a598d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1a598d"]])

export default __exports__